$( document ).ready( () => {

    if ( !$( 'body' ).hasClass( 'post-type-archive' ) ) return;

    const yearFilter = archive.year ?? '';
    const categoryFilter = archive.category ?? '';
    const typeFilter = archive.type ?? '';

    $( '#archive--filters-search' ).on( 'submit', function( e ) {

        $( '#searchInput', this ).val( function( i, value ) {
          return value.replace( /\W+/g, " ");
        });
    
        return e;
    
    });

    $( '#archive--filters-year' ).on( 'change', ( e ) => {

        e.preventDefault();

        window.location.href = $( 'option:selected', e.target ).attr( 'data-url' )

    } )
    $( '#archive--filters-category' ).on( 'change', ( e ) => {

        e.preventDefault();

        window.location.href = $( 'option:selected', e.target ).attr( 'data-url' )

    } )

    $( '#archive--filters-news-type' ).on( 'change', ( e ) => {

        e.preventDefault();

        window.location.href = $( 'option:selected', e.target ).attr( 'data-url' )

    } )

} )